/**
 * Toggle Map Overlay content positioning
 * @author Matt Haynes
 * @package Dunfermline
 */

export default class ToggleContent {
    constructor(elem) {
        if (!elem) {
            return;
        }
        this.elem = elem;
        this.tourContainer = document.getElementById('tour_container');
        this.contentSection = document.querySelector('.content-section');

        this.elem.addEventListener('click', () => {
            this.toggle();
        });
    }

    toggle() {
        this.tourContainer.classList.toggle('toggled');
        this.contentSection.classList.toggle('toggled');
    }
}
